import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

export interface SessionStorageEntry {
  key: string;
  value: string;
}

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  constructor(private readonly router: Router) {
    this.listenToRouteChanges();
  }

  routeKeyMap: { [key: string]: string } = {
    'anagrafiche/utenti': 'pageUtenti',
    'anagrafiche/strutture': 'pageStrutture',
    'anagrafiche/attivita': 'pageAttivita',
    'anagrafiche/medici': 'pageMedici',
    'anagrafiche/campi-aggiuntivi': 'pageCampiAggiuntivi',
    'saggi': 'pageSaggi',
    'attivita': 'pageAttività',
    'anagrafiche/segmentazioni': 'pageFrazioni',
    'segmentazioni': 'pageZone',
    '': 'pageAree',
  };

  private listenToRouteChanges(): void {
    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event) => {
      const currentUrl = event.urlAfterRedirects;
      const matchedKeys = Object.keys(this.routeKeyMap)
        .filter((route) => currentUrl.includes(route))
        .map((route) => this.routeKeyMap[route]);

      const allKeys = Object.values(this.routeKeyMap);

      allKeys.forEach((key) => {
        if (!matchedKeys.includes(key) && sessionStorage.getItem(key)) {
          sessionStorage.removeItem(key);
        }
      });
    });
  }

  clearExcept(keyToKeep: string) {
    Object.values(this.routeKeyMap).forEach((key) => {
      if (key !== keyToKeep) {
        sessionStorage.removeItem(key);
      }
    });
  }

  getItem(key: string): string | null {
    return sessionStorage.getItem(key);
  }

  setItem(items: SessionStorageEntry[]): void {
    items.forEach(({ key, value }) => sessionStorage.setItem(key, value));
  }

  removeItem(keys: string[]): void {
    keys.forEach((key) => sessionStorage.removeItem(key));
  }

  clear(): void {
    sessionStorage.clear();
  }
}
